(function () {

    angular.module('tmx-app')
        .controller('companyBranchesEditCtrl', ['$scope', 'resolvedData', '$state', 'ToastService',
            '$mdDialog', 'BranchService', 'UsersService', 'TMX_FINANCE_CONSTANTS', 'cacheStore', 'tmxUtility', 
        

            function CompanyBranchesEditCtrl($scope, resolvedData, $state, ToastService, $mdDialog,
                BranchService, UsersService, TMX_FINANCE_CONSTANTS, cacheStore, tmxUtility) {
        //Functions/Method
                var branchVM = this;
                branchVM.date = new Date().toJSON();
        //**************Code*******************
                var TenantsList = TMX_FINANCE_CONSTANTS.TENANTS;
                var exists = tmxUtility.exists;
                branchVM.lookup = {};
                branchVM.showStatus = false;
                branchVM.isEdit = false;
                branchVM.endmindate = angular.copy(branchVM.date);
                branchVM.dirtyFormControls = [];
                branchVM.StartDateInvalid = false;
                branchVM.EndDateInvalid = false;
                $scope.dataLoading = false;
                branchVM.branchcodeStatus = false;
                branchVM.BranchCodeReadonly = false;
                branchVM.invalidPhone = false;

                branchVM.productPhoneCheck = true;
                if (resolvedData.Branch.data) {
                    branchVM.branchid = resolvedData.Branch.data.CompanyBranchId;
                }

                branchVM.status = [{
                    HiddenValue: "active",
                    VisibleValue: "Active"
                },
                {
                    HiddenValue: "inactive",
                    VisibleValue: "Inactive"
                }
                ];


                branchVM.showSimpleDialog=function(title,message,callback){
                    var alertConfig={
                        title: title,
                        htmlContent:message,
                        ok: 'OK'
                    };
                    var alert = $mdDialog.alert(alertConfig);
                    $mdDialog
                        .show( alert )
                        .finally(function() {
                            alert = undefined;
                            if(exists(callback))callback();
                        });
                };


                branchVM.lookup.managers = [];
        //////////////////////////////////////////////////////
                branchVM.updateBankManager = function (companyId) {
                    if (!angular.isDefined(companyId) || companyId === null) {
                        branchVM.lookup.managers = [];
                        if (angular.isDefined(branchVM.vm) && angular.isDefined(branchVM.vm.TmxCompanyBranchUsersMapping[0])) {
                            branchVM.vm.TmxCompanyBranchUsersMapping[0].UserId = null;
                        }
                        return;
                    }
                    UsersService.BMLov(companyId).then(function (managerData) {
                        branchVM.lookup.managers = managerData.data;

                    });

                };

                branchVM.ManagerOnBranchID = function (branchid) {
                    UsersService.getUserByBranchId(branchid).then(function (response) {
                        branchVM.lookup.managers = response.data;
                        branchVM.lookup.managers.forEach(function (user) {
                            user.LookupId = user.UserId;
                            user.VisibleValue = user.FirstName;
                        });
                    });


                };

                branchVM.managerSelected = function () { };


        ///////////////////////////////////   STATUS ///////////////////////////////////////////////////////////////////////////
                branchVM.checkBranchCode = function (value) {
            //if(!branchVM.editLoaded){
                    BranchService.checkBranchCode(value).then(function (data) {

                        if (data.status.message == value + " " + "branch already exist.") {
                            branchVM.branchcodeStatus = true;
                        }
                        else {
                            branchVM.branchcodeStatus = false;
                        }
                    });
            //}
            // else{
            //    branchVM.editLoaded = false;
            //}


                };
        //////////////////////////////////////ERRORS//////////////////////////////////////////////////////////////
                branchVM.getFormErrors = function () {
                    if (angular.isDefined(branchVM.dialogForm)) {
                        if (branchVM.dialogForm.$invalid) {
                            return branchVM.dialogForm.$error;
                        }
                    }
                    return undefined;
                };
                branchVM.errorChanged = function (newErrors, oldErrors) {

                    if (newErrors != oldErrors || branchVM.invalidPhone) {
                        branchVM.dirtyFormControls = [];
                        angular.forEach(branchVM.dialogForm, function (value, key) {

                            if ((typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$invalid) ||
                        (typeof value === 'object' && value.$viewValue == "Invalid Date")) {

                                if (key == "BranchPhoneNumber") {
                                    var name = value.$name;
                                    name = name.replace(/([A-Z])/g, ' $1').trim();
                                    value.$name = name;
                                }
                                branchVM.dirtyFormControls.push(value.$name);
                            }
                    //if(typeof value === 'object' && value.hasOwnProperty('$modelValue') && branchVM.invalidPhone){
                    //    if(key == "BranchPhoneNumber"){
                    //         
                    //        value.$invalid = true;
                    //        branchVM.dirtyFormControls.push(value.$name);
                    //    }
                    //}
                        });
                        branchVM.error_msg = "Required field(s): "
                        for (var i = 0; i < branchVM.dirtyFormControls.length; i++) {
                            if (i == branchVM.dirtyFormControls.length - 1) {
                                branchVM.error_msg += branchVM.dirtyFormControls[i];
                            }
                            else
                                branchVM.error_msg += branchVM.dirtyFormControls[i] + ", ";
                        }
                    }
                };
                $scope.$watch(branchVM.getFormErrors, branchVM.errorChanged, true);
        //////////////////////////////////////    SAVE    /////////////////////////////////////////////////////////////////////
                branchVM.save = function (action, form) {
                    branchVM.formSubmitted = true;


                    if (form.$invalid || branchVM.branchcodeStatus || branchVM.invalidPhone) {
                        angular.forEach(form, function (value) {

                            if ((typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$invalid) ||
                        (typeof value === 'object' && value.$viewValue == "Invalid Date") ||
                        (typeof value === 'object' && value.hasOwnProperty('$modelValue') && branchVM.invalidPhone)) {
                                value.$setTouched();
                        //if(key == "BranchPhoneNumber"){
                        //     
                        //    value.$invalid = true;
                        //}
                            }
                        });

                // branchVM.error_msg = "Required field(s): "
                // for (var i = 0; i < dirtyFormControls.length; i++) {
                //  if(i==dirtyFormControls.length-1)
                //  {
                //   branchVM.error_msg += dirtyFormControls[i];
                //  }
                //  else
                //    branchVM.error_msg +=  dirtyFormControls[i] + ", ";
                // };
                // ToastService.showCustomToast("error",branchVM.error_msg);
                    }
                    else {
                        $scope.dataLoading = true;

                        if (angular.isDefined(branchVM.vm.TmxCompanyBranchUsersMapping) && branchVM.vm.TmxCompanyBranchUsersMapping != null) {
                    // if(branchVM.vm.TmxCompanyBranchUsersMapping.length>0)
                    // {
                            if (angular.isDefined(branchVM.vm.TmxCompanyBranchUsersMapping[0]) && branchVM.vm.TmxCompanyBranchUsersMapping[0] != null) {
                                branchVM.vm.TmxCompanyBranchUsersMapping[0].EffectiveStartDate = branchVM.vm.EffectiveStartDate;
                                branchVM.vm.TmxCompanyBranchUsersMapping[0].EffectiveEndDate = branchVM.vm.EffectiveEndDate;
                                var user = [];
                                user.push(branchVM.vm.TmxCompanyBranchUsersMapping[0]);
                                branchVM.vm.TmxCompanyBranchUsersMapping = user;
                            }
                    // }
                        }
                        if (tmxUtility.exists(branchVM.vm.TmxBranchProductsMapping)) {
                            branchVM.vm.TmxBranchProductsMapping.forEach(x => {
                                x.CompanyBranchId = branchVM.branchid
                            });
                        }

                        if (tmxUtility.exists(branchVM.vm.TmxRoleBranchEmailMappingDelete)) {
                            branchVM.temp = angular.copy(branchVM.vm.TmxRoleBranchEmailMapping);

                            branchVM.vm.TmxRoleBranchEmailMappingDelete.forEach(x => {
                                branchVM.temp.push(x);
                            });

                            branchVM.vm.TmxRoleBranchEmailMapping=angular.copy(branchVM.temp);
                        }


                        branchVM.vm.TmxLocation = undefined;
                        branchVM.vm.LocationName = undefined;

                        branchVM.sendData = angular.copy(branchVM.vm);
                        if (angular.isDefined(branchVM.vm.TmxAddress) && angular.isDefined(branchVM.vm.TmxAddress.TmXAddressGeography)) {
                            branchVM.sendData.TmxAddress.TmXAddressGeography = undefined;
                        }
                        branchVM.sendData.$saveOrUpdate().then(function (promise) {
                            $scope.dataLoading = false;
                            if (angular.isDefined($state.data.grid.branchGrid)) $state.data.grid.branchGrid.dataSource.read();
                            if (angular.isDefined(promise)) {
                                if (promise.status >= 400) {
                                    branchVM.formSubmitted = false;
                                    var displayMsg = "";
                                    if (angular.isDefined(promise.data.ModelState)) {
                                        var models = Object.keys(promise.data.ModelState);
                                        models.forEach(function (key) {
                                            displayMsg += (promise.data.ModelState[key])
                                        })
                                    }
                                    else
                                        displayMsg = promise.data.Message;
                            // branchVM.error_msg = promise.statusText;
                                    ToastService.showCustomToast("error",displayMsg);
                                }
                                else {
                                    if (action == "save") {
                                        $state.searchClear = true;
                                        $state.go("^");
                                    }
                                    else if (action == "saveandnew") {
                                        $state.searchClear = true;
                                        $state.reload($state.current);
                                    }
                                }
                            }
                            else
                                ToastService.showCustomToast("error", "Some Error Occured");
                        });
                    }
                };
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                branchVM.cancel = function () {
                    $state.searchClear = true;
                    $state.go("^");
                };
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

                branchVM.addParameter = function(){
                    let bp = {
                        BranchParameterId: 0,
                        CompanyBranchId: branchVM.vm.CompanyBranchId,
                        BranchParameterName: '',
                        BranchParameterValue: '',
                        IsActive:1
                    };
                    branchVM.vm.TmxBranchParameters.push(bp);
                };

                branchVM.addEmailRoleMapping = function(){                    
                    let re = {
                        RoleBranchEmailMappingId: 0,
                        RoleId: 0,
                        BranchId: 0,
                        CommandName: null,
                        Email:null                        
                    };
                    branchVM.vm.TmxRoleBranchEmailMapping.push(re);
                };

                branchVM.removeParameter = function(index){
                    branchVM.vm.TmxBranchParameters.splice(index,1);
                };
                
                branchVM.removeEmailRole = function(item,index){                    
                    branchVM.vm.TmxRoleBranchEmailMapping.splice(index,1);                    
                    if(item.RoleBranchEmailMappingId>0){                    
                    item.RoleBranchEmailMappingId=-item.RoleBranchEmailMappingId;
                    branchVM.vm.TmxRoleBranchEmailMappingDelete.push(item);
                    }                    
                };

                (function InitializePage() {                    
                    PopulateLookups();
                    SetTenantwiseConfigurations();
                    SetFormState();
                })();

        //#region  Private functions

                function PopulateLookups() {
                    branchVM.allActiveProduct = resolvedData.allActiveProducts.map(x => {
                        return {
                            LoanProductId: x.ProductId,
                            LoanProductName: x.ProductName
                        }
                    });
                    branchVM.locations = resolvedData.Locations.data;
                    branchVM.lookup.companies = resolvedData.Companies.data;
                    branchVM.lookup.companies.forEach(function (x) {
                        x.LookupId = x.HiddenValue
                    });

                    branchVM.lookup.roles = resolvedData.RoleLov.data;                    
                    branchVM.lookup.CommandTypeLkp = resolvedData.commandTypeLkp;
                    branchVM.lookup.CommandTypeLkp.forEach(function (x) {
                        x.LookupId = x.HiddenValue
                    });

                    branchVM.gridData = resolvedData.Locations;

                    branchVM.statusLookup = [
                        {
                            LookupId: '1',
                            VisibleValue: 'Active'
                        },
                        {
                            LookupId: '0',
                            VisibleValue: 'Inactive'
                        }
                    ];

                }

                function SetTenantwiseConfigurations() {
                    var LoggedInTenant = "";
                    var LoggedInUserConfigurations = cacheStore.get("Configurations");
                    if (LoggedInUserConfigurations) {
                        LoggedInTenant = LoggedInUserConfigurations.filter(function (item) {
                            return item.ConfigurationKey == 'INTEGRATION_TENANT';
                        })[0];
                    }
                    var tenantName = LoggedInTenant.ConfigurationValue ? LoggedInTenant.ConfigurationValue.toLowerCase() : "";

                    if (TenantsList.SAMBA == tenantName) {
                        branchVM.productPhoneCheck = false;
                    }
                    else {
                        branchVM.productPhoneCheck = true;
                    }
                }

                function SetFormState() {

            ///////////////////// EDIT //////////////////////////////////////////////////////////////////////////////////

                    if (angular.isDefined(resolvedData.Branch.data)) {

                        branchVM.vm = resolvedData.Branch.data;

                        branchVM.vm.EffectiveStartDate = tmxUtility.setStartDate(branchVM.vm.EffectiveStartDate).toJSON();
                        branchVM.vm.EffectiveEndDate = tmxUtility.setEndDate(branchVM.vm.EffectiveEndDate).toJSON();
                //populating options in managers lov:
                        if (angular.isDefined(branchVM.branchid) && branchVM.branchid != null) {
                            branchVM.ManagerOnBranchID(branchVM.branchid);
                        }
                        else {
                            branchVM.lookup.managers = [];
                        }
                        branchVM.BranchCodeReadonly = true;
                        branchVM.isEdit = true;
                        branchVM.editLoaded = true;
                        branchVM.vm.TmxRoleBranchEmailMappingDelete=[];
                    }
                    ////////////////////   ADD///////////////////////////////////////////////////////////////////////////
                    else{
                        branchVM.vm = resolvedData.Branch;
                        branchVM.BranchCodeReadonly = false;
                        branchVM.vm.EffectiveStartDate = tmxUtility.setStartDate(branchVM.date).toJSON();
                        branchVM.isEdit = false;
                        branchVM.editLoaded = false;
                        branchVM.vm.EffectiveEndDate = tmxUtility.setEndDate('2099-12-31').toJSON();
                        branchVM.vm.TmxBranchParameters = [];
                        branchVM.vm.TmxRoleBranchEmailMapping = [];                        
                    }

                    if (tmxUtility.exists(resolvedData.Requests, 'data.RequestId')) {
                        branchVM.readonly = true;
                        branchVM.isEdit = true;
                        branchVM.BranchCodeReadonly = true;
                        branchVM.showSimpleDialog('Alert', 'A modification request is already submitted for this branch. You cannot make changes until the request is Approved/Rejected.');
                    }
                }

        //#endregion
    
        
            }]);
})();